// extracted by mini-css-extract-plugin
module.exports = {"label":"CryptoRewardsOrderType__label__CKy2x"};